﻿import { IMilestoneBase, ISchedule } from "@/interfaces";
import { addScheduleNameToMilestonesRecursive } from "./addScheduleNameToMilestonesRecursive";

export const getFlattenedMilestonesWithSchedule = (
  schedules: ISchedule[]
): IMilestoneBase[] =>
  schedules
    ?.filter(({ isDeleted, milestones }) => !isDeleted && milestones?.length)
    ?.map(({ name, milestones }) =>
      addScheduleNameToMilestonesRecursive(name, milestones)
    )
    ?.flat();
